import {
    apiRequest,
    lemburList,
    ketidakhadiranPerUnitList
} from "../../../../../services/adapters/Laporan/presensiService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", lemburList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
    fetchRowTableKetidakhadiranPerUnit = async (query, cancelToken) => {
        return await apiRequest("get", ketidakhadiranPerUnitList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
}

export default DataTableRepository